module.exports = __webpack_public_path__ + "img/media-expert.8f9097e4.png";